export const APP_VERSION = '2.9.82';
export const APP_BUILD_DATE = '1 Noiembrie 2026';
export const APP_BUILD_TAG = 'RC';

